import React from 'react'
// import './SocialMediaMarketing.css'

import socialMediaMarketingBanner from '../../assets/bannerImages/socialMediaMarketing.png'

import targetedStrategies from '../../assets/images/targetedStrategies.jpg'
import creativeContent from '../../assets/images/creativeContent.jpg'
import provenResults from '../../assets/images/provenResults.jpg'

import strategicPlanning from '../../assets/images/strategicPlanning.jpg'
import engagingContentCreation from '../../assets/images/engagingContentCreation.jpg'
import continuousOptimization from '../../assets/images/continuousOptimization.jpg'


import facebookLogo from '../../assets/logos/facebookLogo.png'
import instagramLogo from '../../assets/logos/instagramLogo.jpg'
import youtubeLogo from '../../assets/logos/youtubeLogo.jpg'
import linkedinLogo from '../../assets/logos/linkedinLogo.jpg'
import XLogo from '../../assets/logos/XLogo.jpg'

import { Link } from 'react-router-dom';



function SocialMediaMarketing(){
    return(
        <div className="socialMediaMarketing">
            <SMMR1/>   
            <SMMR2/>  
            <SMMR3/>      
            <SMMR4/> 
            <SMMR5/>
            <ContactSection/>
        </div>
    )
}
export default SocialMediaMarketing;


function SMMR1(){
    return(
        <div className='smmr1'>
            <img loading="lazy" src={socialMediaMarketingBanner} alt='smm-banner' className='smm-banner-img'/>
            <h1 className='smmr1-head'>Social Media Marketing</h1>
            <div className='overlay'></div>
        </div>
    )
}

function SMMR2(){
    return(
        <div className='smmr2'>
            <div className='strip'>
                <h1>What Is <span>Social Media Marketing</span>?</h1>
                <hr/>   
                <p>Social media marketing is a dynamic way to engage with a vast audience, build brand presence, and drive business growth. It leverages popular platforms to connect with customers, share compelling content, and foster community, all while providing measurable results and cost-effective outreach.</p>
            </div>
        </div>
    )
}

function SMMR3(){
    return(
        <div className='smmr3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Social Media Marketing?
                </h1>
                <p className='rowThreeContext'>
                At Bixian, we help businesses unlock the potential of social media. 
                Our service is all about boosting your brand's visibility, driving engagement, and achieving your marketing goals. 
                With our expertise in targeted strategies and creative content, we make sure your social media presence stands out. 
                Trust us to deliver measurable results and guide you through the world of social media marketing. 
                Backed by over 5 years of experience, our team comprises young and dynamic digital marketing specialists dedicated to your success.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={targetedStrategies} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Targeted Strategies
                            </h2>
                            <p className='boxPara'>
                            We create customized social media plans based on in-depth audience research, ensuring every post resonates with your target market.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={creativeContent} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Creative Content
                            </h2>
                            <p className='boxPara'>
                            Our team produces visually stunning content paired with compelling messaging, capturing your brand's essence and engaging your audience effectively.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={provenResults} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Proven Results
                            </h2>
                            <p className='boxPara'>
                            With our data-driven approach, we consistently deliver measurable success, whether it's boosting brand awareness or driving sales conversions.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}


function SMMR4(){
    return(
        <div className='smmr4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Our Process at Bixian involves understanding your goals, crafting strategies, and driving results. We start by getting to know your business and audience, then create a plan that works for you. With us, you're part of the journey, ensuring success every step of the way.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={strategicPlanning} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Strategic Planning</h2>
                        <p className='boxPara'>We create a personalized social media plan based on your goals and audience, ensuring effective results.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={engagingContentCreation} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Engaging Content Creation</h2>
                        <p className='boxPara'>Our team crafts captivating content that connects with your audience, enhancing brand visibility and engagement.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={continuousOptimization} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Continuous Optimization</h2>
                        <p className='boxPara'>We monitor performance and adapt our strategy to maximize impact, keeping your social media presence effective and dynamic.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
/* tomorrow when you start working from here agian, download the required logos for the "platforms we use" section.*/
/* tomorrow when you start working from here agian, download the required logos for the "platforms we use" section.*/
/* tomorrow when you start working from here agian, download the required logos for the "platforms we use" section.*/
/* tomorrow when you start working from here agian, download the required logos for the "platforms we use" section.*/
/* tomorrow when you start working from here agian, download the required logos for the "platforms we use" section.*/
/* tomorrow when you start working from here agian, download the required logos for the "platforms we use" section.*/
function SMMR5(){
    return(
        <div className='smmr5'>
            <h1 className='rowFiveHead'>Where <span>Your Brand</span> is Promoted?</h1>
            <div className='container'>
                <div className='item facebook'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={facebookLogo} alt='' className='smLogo'/>
                </div>
                <div className='item instagram'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={instagramLogo} alt='' className='smLogo'/>

                </div>
                <div className='item youtube'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={youtubeLogo} alt='' className='smLogo'/>

                </div>
                <div className='item linkedin'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={linkedinLogo} alt='' className='smLogo'/>

                </div>
                <div className='item X'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={XLogo} alt='' className='smLogo'/>
                    
                </div>
            </div>
        </div>
    )
}

export function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Social Media Marketing?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}